import { render, staticRenderFns } from "./TotalDataSum.vue?vue&type=template&id=49a601a9&scoped=true"
import script from "./TotalDataSum.vue?vue&type=script&lang=js"
export * from "./TotalDataSum.vue?vue&type=script&lang=js"
import style0 from "./TotalDataSum.vue?vue&type=style&index=0&id=49a601a9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a601a9",
  null
  
)

export default component.exports